import { removeTemporaryUUID, temporaryUUID } from '@/js/composables/useTemporaryUUID';
import { ICoachingForm, ICoachingFormReasonCode, RequestPostCoachingForm } from './types';
import { __ } from '@/js/stores/expressions';

export const transformCoachingFormDraftToRequest = (
    formDraft: ICoachingForm
): RequestPostCoachingForm => {
    const ratings = formDraft.approvalRatings?.ratings || [];

    const criticalQuestionFallbackRatingName = formDraft.approvalRatings?.ratings?.find(
        (rating) => rating.id === formDraft.approvalRatings?.criticalQuestionFallbackRatingId
    )?.name;

    const approvalRatings = {
        criticalQuestionFallbackRatingName,
        ratings,
    };

    const codes = transformReasonCodesToNestedReasonCodes(formDraft.reasonCodes?.codes || []).map(
        (code) => ({
            code: code.code,
            childCodes: code.childCodes?.map((child) => child.code),
        })
    );

    const reasonCodes = formDraft.reasonCodes ? { ...formDraft.reasonCodes, codes } : undefined;

    const { id: _id, ...formDraftWithoutId } = formDraft;

    let request: RequestPostCoachingForm = {
        ...formDraftWithoutId,
        approvalRatings: formDraft.useApprovalRating ? approvalRatings : undefined,
        reasonCodes: formDraft.useReasonCodes ? reasonCodes : undefined,
    };

    request.sections.forEach((section) => {
        section.questions.forEach((question) => {
            if (question.notApplicable) {
                question.answers.push({
                    id: temporaryUUID(),
                    label: question.notApplicableLabel || __('not-applicable-short'),
                    points: 0,
                    notApplicable: true,
                });
            }
        });
    });

    request = removeTemporaryUUID(request, ['id', 'parentId']);

    return request as RequestPostCoachingForm;
};

export const transformReasonCodesToNestedReasonCodes = (codes: ICoachingFormReasonCode[]) => {
    return codes.reduce((acc, code) => {
        if (!code.parentId) {
            acc.push({ ...code, childCodes: [] });
        } else {
            const parent = acc.find((item) => item.id === code.parentId);

            if (parent) {
                parent.childCodes?.push(code);
            }
        }
        return acc;
    }, [] as ICoachingFormReasonCode[]);
};
